import { render, staticRenderFns } from "./TableKpiCompareItem.vue?vue&type=template&id=223fa071"
import script from "./TableKpiCompareItem.vue?vue&type=script&lang=ts"
export * from "./TableKpiCompareItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports